var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"preloader"}},[_c('div',{staticClass:"preloader"},[_c('div',[_c('div',{staticClass:"one"}),_vm._v(" "),_c('div',{staticClass:"two"}),_vm._v(" "),_c('div',{staticClass:"three"}),_vm._v(" "),_c('div',{staticClass:"four"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ae4836","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preloader.vue
// module id = null
// module chunks = 